import handleApi from "../utils/api";

export const saveChatUrl = async (data) => {
  const params = {
    chat_url: data.chatUrl
  };
  const res = await handleApi(`/client-calls/save-chat-url/${data.roomId}`, "PUT", params);
  return res;
};
